// types
import { i18nEaiDeliveryPoints } from 'models/i18n';
import { DeliveryPointValidationArguments } from 'views/modules/Eai/DeliveryPoints/DeliveryPointDetail/DeliveryPointCharacteristics/DeliveryPointReservedCapacityCharacteristics/deliveryPointReservedCapacityGuardingValidationSchema';

// ==============================|| I18N EN DELIVERY POINTS ||============================== //

const enEaiDeliveryPoints: i18nEaiDeliveryPoints = {
  createDeliveryPointWizard: {
    title: 'Create delivery point',
    step01: 'Delivery point identification',
    step02: 'Delivery point role',
    save: 'Create delivery point'
  },
  deliveryPointDetail: {
    basicInfoTab: {
      title: 'Delivery Point information'
    },
    characteristicsTab: {
      title: 'Characteristics',
      technicalCharacteristics: {
        title: 'Characteristics',
        input: {
          reserved_capacity: 'Reserved capacity - offtake',
          maximum_reserved_capacity: 'Maximum reserved capacity - offtake',
          reserved_capacity_supply: 'Reserved capacity - supply',
          maximum_reserved_capacity_supply: 'Maximum reserved capacity - supply'
        },
        validation: {
          'reserved_capacity-required': 'Reserved capacity required',
          'maximum_reserved_capacity-required':
            'Maximum reserved capacity required',
          'reserved_capacity-number':
            'Reserved capacity must be number in decimal form',
          'reserved_capacity-number-range':
            'Reserved capacity must be a positive number',
          'maximum_reserved_capacity-number':
            'Maximum reserved capacity must be in decimal format',
          'maximum_reserved_capacity-number-range':
            'Maximum reserved capacity must be a positive number'
        }
      },
      reservedCapacityCharacteristics: {
        title: 'RC guarding parameters',
        input: {
          reserved_capacity_guard_period_start_restriction_offset:
            'Start time of restrictive phase',
          reserved_capacity_guard_phase_one_reserve: 'Preventive phase reserve',
          reserved_capacity_guard_phase_two_reserve:
            'Restriction phase reserve',
          reserved_capacity_guard_earliest_restriction_start_offset:
            'Earliest guarding action time',
          reserved_capacity_guard_check_periodicity: 'Guarding frequency',
          reserved_capacity_guard_check_algorithm: 'Algorithm type',
          reserved_capacity_utilization_alarm_utilization_threshold:
            'Alarm limit value for RK usage',
          reserved_capacity_utilization_alarm_time_threshold:
            'Time limit for reaching the RK limit value for alarm'
        },
        validation: {
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PERIOD_START_RESTRICTION_OFFSET_REQUIRED]:
            'Start time of restrictive phase is mandatory',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PERIOD_START_RESTRICTION_OFFSET_NUMBER]:
            'Start time of restrictive phase must be in integer form',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_ONE_RESERVE_REQUIRED]:
            'Preventive phase reserve is mandatory',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_ONE_RESERVE_NUMBER]:
            'Preventive phase reserve must be number with max 2 decimal places',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_ONE_RESERVE_MAX]:
            'Preventive phase reserve must not exceed Reserved capacity - offtake',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_TWO_RESERVE_REQUIRED]:
            'Restriction phase reserve is mandatory',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_TWO_RESERVE_NUMBER]:
            'Restriction phase reserve must be number with max 2 decimal places',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_PHASE_TWO_RESERVE_MAX]:
            'Restriction phase reserve must not exceed Reserved capacity - offtake',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_EARLIEST_RESTRICTION_START_OFFSET_REQUIRED]:
            'Earliest guarding action time is mandatory',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_EARLIEST_RESTRICTION_START_OFFSET_NUMBER]:
            'Earliest guarding action time must be in integer form',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_CHECK_PERIODICITY_REQUIRED]:
            'Frequency of guarding is mandatory',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_GUARD_CHECK_ALGORITHM_REQUIRED]:
            'Algorithm type is mandatory',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_UTILIZATION_ALARM_UTILIZATION_THRESHOLD_REQUIRED]:
            'Alarm limit value for RK usage is mandatory',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_UTILIZATION_ALARM_UTILIZATION_THRESHOLD_NUMBER]:
            'Alarm limit value for RK usage must be in integer form',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_UTILIZATION_ALARM_TIME_THRESHOLD_REQUIRED]:
            'Time limit for reaching the RK limit value for alarm is mandatory',
          [DeliveryPointValidationArguments.RESERVED_CAPACITY_UTILIZATION_ALARM_TIME_THRESHOLD_NUMBER]:
            'Time limit for reaching the RK limit value for alarm must be in integer form'
        }
      }
    },
    gdsListTab: {
      title: 'GDS'
    },
    assignmentsTab: {
      title: 'Assignments'
    },
    basicInfo: {
      title: 'Basic information',
      input: {
        DeliveryPointId: 'Delivery Point ID',
        DeliveryPointEic: 'EIC',
        DeliveryPointRole: 'Role',
        DeliveryPointName: 'Delivery Point Name',
        DeliveryPointDescription: 'Delivery Point Description'
      },
      validation: {
        'DeliveryPointEic-required': 'EIC is mandatory',
        'DeliveryPointEic-length': 'Length must be 16',
        'DeliveryPointEic-exists': 'EIC must be unique',
        'DeliveryPointName-required': 'Delivery point name is mandatory',
        'DeliveryPointName-max': 'Maximum length exceeded',
        'DeliveryPointDescription-max': 'Maximum length exceeded'
      }
    },
    basicAddressInfo: {
      title: 'Delivery Point Address',
      input: {
        StreetName: 'Street',
        StreetNumber: 'Street Number',
        UnitNumber: 'Unit Number',
        PostalCode: 'Postal Code',
        City: 'City'
      },
      validation: {
        'StreetName-required': 'Street Name is mandatory',
        'StreetName-max': 'Maximum length exceeded',
        'StreetNumber-required': 'Street Number is mandatory',
        'StreetNumber-max': 'Maximum length exceeded',
        'UnitNumber-max': 'Maximum length exceeded',
        'PostalCode-required': 'Postal Code is mandatory',
        'PostalCode-length': 'Length must be 5',
        'City-required': 'City is mandatory',
        'City-max': 'Maximum length exceeded'
      }
    },
    gdsList: {
      title: 'List of GDS',
      searchInput: 'Enter name',
      createEntityButton: 'Register GDS',
      filter: {
        validity: 'Only valid',
        showOnlyValid: 'Show only valid'
      },
      input: {
        name: 'Name',
        searchString: 'Enter ID / Name',
        showOnlyValid: 'Only valid'
      },
      columns: {
        id: 'ID',
        name: 'Name',
        validity: 'Validity',
        actions: 'Actions'
      },
      create: 'Register GDS'
    },
    gdsDetail: {
      searchInput: 'Enter name',
      createEntityButton: 'Register GDS',
      input: {
        id: 'ID',
        name: 'Name',
        validity: 'Validity',
        actions: 'Actions'
      },
      basicGdsInfoTab: {
        title: 'Basic info'
      },
      basicInfo: {
        title: 'Basic Info',
        input: {
          id: 'GDS ID',
          name: 'Name',
          validTo: 'Valid to'
        }
      },
      gdsDevices: {
        title: 'Devices list',
        create: 'Add device',
        remove: 'Remove device'
      }
    },
    assignments: {
      changeAssignmentButton: 'Change assignment',
      emsPartyName: 'Delivery Point Owner',
      balanceGroupName: 'Balance Group',
      validity: 'Validity',
      historyOfAssignments: 'History of assignments',
      columns: {
        deliveryPointOwner: 'Delivery point owner',
        balanceGroup: 'Balance group',
        mds: 'MDS',
        validity: 'Validity'
      }
    },
    gdsDevicesList: {
      title: '',
      id: 'Device Name',
      name: 'Device Type',
      columns: {
        DeviceId: 'Device Name',
        DeviceType: 'Device Type',
        actions: 'Actions'
      }
    },
    mdsTab: {
      title: 'End delivery points',
      columns: {
        eic: 'EIC',
        id: 'ID',
        name: 'Delivery point name'
      }
    }
  },
  deliveryPointList: {
    title: 'List of Delivery Points',
    searchInput: 'Enter ID / EIC / name',
    createEntityButton: 'Create Delivery Point',
    columns: {
      id: 'ID',
      eic: 'EIC',
      name: 'Name',
      role: 'Role',
      address: 'Address',
      actions: 'Actions'
    },
    filter: {
      role: 'Role'
    }
  },
  input: {
    DeliveryPointName: 'Delivery point name',
    DeliveryPointEic: 'EIC',
    DeliveryPointRole: 'Delivery point role',
    name: 'Name'
  },
  validation: {
    'DeliveryPointName-required': 'Delivery point name is mandatory',
    'DeliveryPointName-max': 'Maximum length exceeded',
    'DeliveryPointGDSName-required': 'Delivery point GDS name is mandatory',
    'DeliveryPointGDSName-max': 'Maximum length exceeded',
    'DeliveryPointEic-required': 'Delivery point EIC is mandatory',
    'DeliveryPointEic-length': 'Length must be 16',
    'DeliveryPointEic-available': 'EIC must be unique',
    'DeliveryPointRole-required': 'Delivery point Role is mandatory',
    'DeliveryPointRole-max': 'Maximum length exceeded'
  },
  createGDSDialog: {
    input: {
      balancingGroupId: 'Balance Group Name',
      marketParticipantId: 'Market Participant Name'
    }
  },
  changeDPAssignmentDialog: {
    input: {
      balanceGroup: 'Balance Group',
      marketParticipant: 'Delivery point owner',
      deliveryPoint: 'MDS'
    },
    validation: {
      'BalanceGroup-required': 'Balance group is required',
      'MarketParticipant-required': 'Market Participant is required',
      'DeliveryPoint-required': 'MDS is required'
    }
  }
};

export default enEaiDeliveryPoints;
